import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '../../design-system';
import { useIsVisible, useRepairsGroupQuery } from '../../hooks';
import {
  DashboardHeader,
  DashboardTable,
  DashboardTableCell,
  DashboardTableHeader,
  DashboardTableRow,
  DashboardTableRowLoading,
  DashboardTableRows,
  DashboardWrapper,
} from '../dashboard';
import { RepairGetAllGroupQuery } from '../../types';

const getPendingCount = (row: RepairGetAllGroupQuery['data'][number]) =>
  row.customRepair?.pendingCount ?? row.repair.filter((obj) => obj.status === 'PENDING').length;

const getActiveCount = (row: RepairGetAllGroupQuery['data'][number]) =>
  row.customRepair?.activeCount ?? row.repair.filter((obj) => obj.status === 'ACTIVE').length;

export const RepairsGroup = () => {
  const navigate = useNavigate();
  const [isVisibleLoading, loadingRef] = useIsVisible();

  const {
    data: { data, totalCount },
    isSuccess,
    isFetched,
    fetchNextPage,
    isFetching,
  } = useRepairsGroupQuery();

  useEffect(() => {
    if (!isVisibleLoading || isFetching) return;

    fetchNextPage();
  }, [isVisibleLoading]);

  const handleRowClick = (row: RepairGetAllGroupQuery['data'][number]) => {
    navigate(`/dashboard/repairs/${row.id}`, { state: { number: row.number } });
  };

  return (
    <DashboardWrapper rows={'4rem 1fr'}>
      <DashboardHeader>
        <Typography variant={'textXL'} weight={'bold'}>
          Repairs
        </Typography>
      </DashboardHeader>
      <DashboardTable>
        <DashboardTableHeader>
          <DashboardTableCell>Container</DashboardTableCell>
          <DashboardTableCell align={'right'}>Pending</DashboardTableCell>
          <DashboardTableCell align={'right'}>Active</DashboardTableCell>
        </DashboardTableHeader>
        <DashboardTableRows>
          {isSuccess &&
            data.map((row, i) => (
              <DashboardTableRow key={i} onClick={() => handleRowClick(row)}>
                <DashboardTableCell>{row.number}</DashboardTableCell>
                <DashboardTableCell align={'right'}>{getPendingCount(row)}</DashboardTableCell>
                <DashboardTableCell align={'right'}>{getActiveCount(row)}</DashboardTableCell>
              </DashboardTableRow>
            ))}
          {(!isFetched || data.length !== totalCount) && (
            <DashboardTableRowLoading key={data.length} setRef={loadingRef} />
          )}
        </DashboardTableRows>
      </DashboardTable>
    </DashboardWrapper>
  );
};
